<template>
    <div class="screen-column">
        <div>
            <a-icon @click="setScreenCondition" :class="{'active':screenActive}" style="margin-right:25px;cursor:pointer;font-size:16px;" type="align-center" />
            <span class="tip-icon" v-if="conditionNum!=0">{{conditionNum}}</span>
        </div>
        <a-modal :centered='true' :maskClosable='false' v-model.trim="screenModal" title="" :closable='false' footer='' width='720px'>
            <div class="screen-modal">
                <div class="modal-head">
                    <span style="color:rgba(18, 18, 18, 1);font-size:14px;font-weight:bold;margin-right:16px;">设置筛选条件</span>
                    <span @click="newSetCondition" style="color:rgba(24, 144, 255, 1);font-size:13px;cursor:pointer;">重置</span>
                    <a-icon @click="cancelScreen" style="float:right;color:rgba(158, 172, 196, 1);font-size:16px;cursor:pointer;" type="close" />
                </div>
                <div style="max-height:350px;overflow-y:auto;border-top:1px solid rgba(229, 229, 229, 1);border-bottom:1px solid rgba(229, 229, 229, 1);padding:8px 24px 20px">
                    <a-row v-for="(item,index) in viewScreenData" :key='index' style="margin-bottom:12px;">
                        <a-col :span="4">
                            {{item.fieldName}}
                        </a-col>
                        <a-col :span="6">
                            <a-select v-model="item.selectedCondition" style="width:100%;height:32px;border:1px solid rgba(229, 229, 229, 1)" @change="selectConChange(item,index)">
                                <a-select-option :value="item1.value" v-for="(item1,index1) in item.methodList" :key='index1'>
                                    {{item1.name}}
                                </a-select-option>
                            </a-select>
                        </a-col>
                        <a-col :span="14" style="padding-left:12px;">
                            <Linkage ref="child4"></Linkage>
                        </a-col>
                    </a-row>
                </div>
                <div class="btn-group">
                    <a-button type="primary" @click="sureScreen">确认</a-button>
                    <a-button style="border:none;color:rgba(158, 172, 196, 1);" @click="cancelScreen">取消</a-button>
                </div>
            </div>
        </a-modal>
    </div>
</template>
<script>
import Linkage from './Linkage'
export default {
    props:[],
    components: {Linkage},
    data(){
        return{
            screenModal: false,
            checkAll: false,
            moduleId: '',
            viewScreenData: [],
            conditionList: [],
            copyData: [],
            selectedDigitalEmployee: '',
            callingLabelList: [],
            screenActive: false,
            conditionNum: 0
        }
    },
    methods: {
        setScreenCondition() {
            this.screenModal = true
            this.screenActive = !this.screenActive
        },
        selectConChange(item, index) {
            this.$refs.child4[index].getPassData(item,index)
        },
        getData(moduleId, conditionList) {
            this.moduleId = moduleId
            this.viewScreenData = this.deepClone(conditionList)
            this.copyData = this.deepClone(conditionList)
            this.conditionNum = 0
            this.$forceUpdate()
            // this.newSetCondition()
            setTimeout(()=>{
                this.newSetCondition()
            },500)
        },  
        deepClone(obj){
            let _obj = JSON.stringify(obj),
            objClone = JSON.parse(_obj);
            return objClone
        },  
        newSetCondition() {
            let data = this.deepClone(this.copyData)
            this.viewScreenData = data
            for(let i = 0; i < this.viewScreenData.length; i++){
                this.$refs.child4[i].getPassData(this.viewScreenData[i],i)
            }
            this.$forceUpdate()
        },  
        screenOperate() {
            this.screenModal = true
        },
        cancelScreen() {
            this.screenModal = false
        },
        sureScreen() {
            this.screenModal = false
            let data = this.$refs.child4
            let arr = []
            for(let i = 0; i < data.length; i++){
                let obj = {}
                if(data[i]['_data']['viewportData']['selectedCondition']!='ALL'&&data[i]['_data']['viewportData']['selectedCondition']!=''){
                    if(data[i]['_data']['viewportData']['fieldType']=='TIME'){
                        if(data[i]['_data']['viewportData']['selectedCondition']=='BETWEEN'){
                            obj.valueList[0] = data[i]['_data']['viewportData']['valueList'][0]!=null?(data[i]['_data']['viewportData']['valueList'][0]).format('YYYY-MM-DD HH:mm:ss'):null
                            obj.valueList[1] = data[i]['_data']['viewportData']['valueList'][1]!=null?(data[i]['_data']['viewportData']['valueList'][1]).format('YYYY-MM-DD HH:mm:ss'):null
                        }else{
                            obj.valueList[0] = data[i]['_data']['viewportData']['valueList'][0]!=null?(data[i]['_data']['viewportData']['valueList'][0]).format('YYYY-MM-DD HH:mm:ss'):null
                        }
                    }else if(data[i]['_data']['viewportData']['fieldType']=='SELECT_SINGLE'&&data[i]['_data']['viewportData'].selectedCondition!='ALL'&&data[i]['_data']['viewportData'].selectedCondition!='ISNULL'){
                        obj.valueList = data[i]['_data']['viewportData']['valueList'][0]
                    }else if(data[i]['_data']['viewportData']['fieldType']=='ASSOCIATED_SINGLE'&&data[i]['_data']['viewportData'].selectedCondition!='ALL'&&data[i]['_data']['viewportData'].selectedCondition!='ISNULL'){
                        obj.valueList = data[i]['_data']['viewportData']['valueList'][0]
                    }else{
                        obj.valueList = data[i]['_data']['viewportData']['valueList']
                    }
                    obj.id = data[i]['_data']['viewportData']['fieldId']
                    obj.method = data[i]['_data']['viewportData']['selectedCondition']
                    arr.push(obj)
                }
            }
            this.conditionList = arr
            this.conditionNum = 0
            for(let i = 0; i < this.conditionList.length; i++){
                if(this.conditionList[i]['method']!=undefined&&this.conditionList[i]['method']!='ALL'){
                    this.conditionNum++
                }
            }
            this.$parent.queryScreenColumnData()
            this.$parent.currentPage = 1
            this.$parent.pageSize = 10
            this.$parent.queryBasicData()
        },
    }
}
</script>
<style scoped lang="less">
    .screen-column{
        display: inline-block;
        .operate-img{
            width: 20px;
            margin-right: 20px;
            cursor: pointer;
        }
        .tip-icon{
            color: #fff;
            font-size: 12px;
            position: absolute;
            top: -10px;
            right: 4px;
            display: inline-block;
            width: 18px;
            height: 18px;
            text-align: center;
            line-height: 18px;
            border-radius: 9px;
            background: #f5574e;
        }
    }
    .screen-modal{
        .modal-head{
            height: 55px;
            padding: 20px 20px 0 24px;
        }
        .btn-group{
            height: 62px;
            padding: 16px 24px 0 0;
            button{
                float: right;
                margin-left: 8px;
                height: 32px;
                line-height: 32px;
                font-size: 13px;
            }
        }
    }
</style>